import React, {useState} from 'react';
import {formatDate} from '../../helpers';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Fab,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Theme,
  useMediaQuery,
  Zoom,
} from '@mui/material';

import makeStyles from "@mui/styles/makeStyles";
import {Add, Close} from '@mui/icons-material';
import {useLocation, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../..//redux/hooks";
import Strings from "../../assets/strings";
import {ConfirmDialog, LoadingProgress, TopBarDialog} from "../../components";
import {IAppUser} from "../../redux/types/IAppUser";
import {agregarAppUserNota, eliminarAppUserNota} from "../../redux/reducers/appUsersReducers";


const useStyles = makeStyles((theme:Theme) => ({
  root: {
    // width: '100%',
    // overflowX: 'auto',
  },
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& > label':{
      marginRight: 0
    }
  },
}));
interface INota {
  comentario?:string,
  companiaId?:number,
  fechaCreacion?:string,
  id?:number,
  usuarioCreadoPor?:string
}

export default function ListNotasUser({ data = [], onTabClick,notasCount }:{notasCount?:number, data:INota[], onTabClick:(tab:number)=>void}) {
  const classes = useStyles();

  let navigate = useNavigate();
  const {state:urlState, pathname} = useLocation();
  let dispatch = useAppDispatch();
  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  let {byId:appUser = ({} as IAppUser), status} = useAppSelector(state => state.appUsers);

  const [showAddNew, setShowAddNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState<INota>({comentario:""});
  const submitNota = (e:React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(false)

    dispatch(agregarAppUserNota({
      comentario: state.comentario,
      companiaId:  appUser.id
    })).then(v=>{
      if(v.payload){
        setState({comentario:""})
        setShowAddNew(false)
      }
    })
  };


  //----
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event:any, newPage:number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event:React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <div className={classes.barTitle}>
        <Box display={"flex"}>
          <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.pagos}</Button>
          <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>Modulos</Button>
          <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px",background:"#eeeeee !important"}}>
            {Strings.notas} ({notasCount ??0})
          </Button>
        </Box>
      </div >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell/>
              <TableCell sx={{width:150}}>{Strings.fecha}</TableCell>
              <TableCell>{Strings.comentario}</TableCell>
              <TableCell>{Strings.creadoPor}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n =>
                <TableRow key={n.id}>
                  <TableCell className={"actionCell"}>
                        <IconButton
                            onClick={()=>navigate(pathname,{state:{confirmDialog: {notaId: n.id!}}})}
                            size="large">
                          <Close className={"text-red"}/>
                        </IconButton>
                  </TableCell>
                  <TableCell>{formatDate(n.fechaCreacion)} {formatDate(n.fechaCreacion,"h:mm a")}</TableCell>
                  <TableCell>{n.comentario}</TableCell>
                  <TableCell>{n.usuarioCreadoPor}</TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 10 &&
        <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            SelectProps={{
              inputProps: { 'aria-label': 'No. registros' },
              native: true,
            }}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
          <Zoom
              in={true}
              // timeout={transitionDuration}
              // style={{
              //   transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,
              // }}
              unmountOnExit
          >
            <Fab variant="extended" onClick={()=>setShowAddNew(true)}
                 sx={(theme)=>({
                   position: 'fixed',
                   right:smVewport?theme.spacing(1):undefined,
                   bottom: theme.spacing(2),
                   zIndex:2
                 })} size="small" color="primary" aria-label="agregar">

              <Add sx={{mr: 1}}/>
              {Strings.agregar} {Strings.nota}
            </Fab>
          </Zoom>




      {urlState?.confirmDialog?.notaId &&
          <ConfirmDialog onConfirm={()=>{
            dispatch(eliminarAppUserNota({companyId:appUser.id!, id:urlState?.confirmDialog?.notaId}))
          }}/>
      }




      <Dialog fullScreen={smVewport} open={showAddNew} fullWidth maxWidth={"xs"} disableEscapeKeyDown>
        <TopBarDialog title={Strings.agregar +" "+Strings.nota} onClose={()=>setShowAddNew(false)} nofullScreen/>
        <DialogContent>
          {loading && <LoadingProgress vh={false} />}
          <form onSubmit={submitNota} id={"formNota"}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                    required
                    multiline
                    label={Strings.nota}
                    placeholder={Strings.agregar+" "+Strings.notas}
                    value={state.comentario}
                    name="nota"
                    onChange={({target})=>setState(prevState => ({...prevState, comentario: target.value}))}
                    fullWidth
                    rows={3}
                    inputProps={{
                      maxLength:256
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setShowAddNew(false)} color="warning" variant={"text"}>{Strings.cancelar}</Button>
          <Button type="submit" form={"formNota"} color="primary" variant={"outlined"} disabled={loading}>
            {!!state.id ? Strings.actualizar : Strings.guardar}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

